function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-5);}.cls-5{fill:url(#linear-gradient-6);}.cls-6{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -0.69,
  y1: 39.35,
  x2: 306.09,
  y2: 39.35,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#90cca2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00b4e6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -0.69,
  y1: 49.5,
  x2: 306.09,
  y2: 49.5,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -0.69,
  y1: 49.56,
  x2: 306.09,
  y2: 49.56,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: -0.69,
  y1: 159.35,
  x2: 306.09,
  y2: 159.35,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: -0.69,
  y1: 169.55,
  x2: 306.09,
  y2: 169.55,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: -0.69,
  y1: 169.5,
  x2: 306.09,
  y2: 169.5,
  xlinkHref: "#linear-gradient"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M66.5,19.6A21.33,21.33,0,0,1,64,29.8a18.57,18.57,0,0,1-7.9,7.6A24.44,24.44,0,0,1,62,40.1a16.41,16.41,0,0,1,4.5,4.25A19.43,19.43,0,0,1,69.3,50.3a27.17,27.17,0,0,1,1,7.7,22.28,22.28,0,0,1-1.75,9.2,18,18,0,0,1-4.75,6.45,19.87,19.87,0,0,1-6.9,3.8,26.79,26.79,0,0,1-8.2,1.25H0V0H44.9a30.18,30.18,0,0,1,8.2,1.1A19.64,19.64,0,0,1,60,4.55a16.47,16.47,0,0,1,4.75,6.1A21,21,0,0,1,66.5,19.6Zm-24,10.9A12,12,0,0,0,49,26.75a9.6,9.6,0,0,0,2.2-6.35,7.84,7.84,0,0,0-2.75-6.5,10.14,10.14,0,0,0-6.55-2.2H15.7v26ZM54.1,54.9a10.64,10.64,0,0,0-3.8-8.4,17.78,17.78,0,0,0-9.9-4L15.7,49.7V67.1H41.4q6.2,0,9.45-3.1T54.1,54.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M97.3,59.5a15.77,15.77,0,0,0,6.4,7.4,20.36,20.36,0,0,0,10.7,2.6,29,29,0,0,0,10.95-2,22.83,22.83,0,0,0,9-6.8l10.1,7.7A36.18,36.18,0,0,1,116,81.7a41.27,41.27,0,0,1-13.8-2.25,33.61,33.61,0,0,1-11.15-6.4A29.78,29.78,0,0,1,83.55,63,31.37,31.37,0,0,1,80.8,49.6a32.39,32.39,0,0,1,2.6-13.15,30.71,30.71,0,0,1,7.1-10.2,32,32,0,0,1,10.65-6.6A37,37,0,0,1,114.5,17.3a34.92,34.92,0,0,1,12.85,2.3A31.34,31.34,0,0,1,137.5,26a30.33,30.33,0,0,1,6.85,9.7A33.37,33.37,0,0,1,147.2,48Zm17.9-30q-8.91,0-14,5T95.5,47.9l36-8.6a16.71,16.71,0,0,0-6.8-7.5A19.5,19.5,0,0,0,115.2,29.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M180.4,20.4H195V32.6H180.4V60.2A6.5,6.5,0,0,0,182,64.85a6.21,6.21,0,0,0,4.75,1.65H196V78.7H180.1a18,18,0,0,1-6-1,14.38,14.38,0,0,1-5-2.9,13.47,13.47,0,0,1-3.3-4.65,15.48,15.48,0,0,1-1.2-6.25V32.6H152.8V20.4h11.8V0h15.8Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M255,20.4h13.8V78.7H255.4L253.5,71a21.05,21.05,0,0,1-4.4,4.15,28.33,28.33,0,0,1-5.65,3.1,34.21,34.21,0,0,1-6.35,1.9,28.9,28.9,0,0,1-6.5.55,29.6,29.6,0,0,1-11.55-2.5,31.62,31.62,0,0,1-9.6-6.5A29.93,29.93,0,0,1,202.9,62a31,31,0,0,1-2.4-12.25,31.18,31.18,0,0,1,18.8-28.95,27.72,27.72,0,0,1,11.2-2.35,34.49,34.49,0,0,1,13.1,2.4,24.26,24.26,0,0,1,9.6,6.8ZM233.7,68.5a17.85,17.85,0,0,0,6.8-1.3,16,16,0,0,0,5.55-3.75,17.76,17.76,0,0,0,3.7-6,21.49,21.49,0,0,0,1.35-7.8,22.1,22.1,0,0,0-1.35-8,17.76,17.76,0,0,0-3.7-6A16,16,0,0,0,240.5,32a18.43,18.43,0,0,0-13.6,0,15.85,15.85,0,0,0-5.55,3.75,17.6,17.6,0,0,0-3.7,6,22.1,22.1,0,0,0-1.35,8,21.49,21.49,0,0,0,1.35,7.8,17.6,17.6,0,0,0,3.7,6,15.85,15.85,0,0,0,5.55,3.75A17.82,17.82,0,0,0,233.7,68.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M0,120H15.7l37,56.9V120H68.5v78.7H52.7L15.8,142.1v56.6H0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M78.5,169.7a32.31,32.31,0,0,1,2.7-13.4,30.32,30.32,0,0,1,7.35-10.2,32.51,32.51,0,0,1,10.85-6.45,39.55,39.55,0,0,1,26.3,0,32.61,32.61,0,0,1,10.85,6.45,31,31,0,0,1,7.4,10.2,31.85,31.85,0,0,1,2.75,13.4A31.17,31.17,0,0,1,144,183a30.81,30.81,0,0,1-7.4,10.05,33,33,0,0,1-10.85,6.4,39.55,39.55,0,0,1-26.3,0,32.9,32.9,0,0,1-10.85-6.4A30.12,30.12,0,0,1,81.2,183,31.61,31.61,0,0,1,78.5,169.7Zm34.1,19.9a18.37,18.37,0,0,0,7.3-1.45,16.92,16.92,0,0,0,5.85-4.1,19.47,19.47,0,0,0,3.85-6.3,22.38,22.38,0,0,0,1.4-8.05,23.49,23.49,0,0,0-1.4-8.25,18.59,18.59,0,0,0-3.85-6.35,17.34,17.34,0,0,0-5.85-4,18.37,18.37,0,0,0-7.3-1.45,17.76,17.76,0,0,0-7.35,1.5,17.46,17.46,0,0,0-5.8,4.15,19.12,19.12,0,0,0-3.85,6.35,22.81,22.81,0,0,0-1.4,8.1,22.38,22.38,0,0,0,1.4,8.05,19.3,19.3,0,0,0,3.85,6.3,16.92,16.92,0,0,0,5.8,4.1A18.23,18.23,0,0,0,112.6,189.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M189.3,198.7h-16l-24.7-58.3h16.1l16.6,39.9,16.6-39.9H214Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M233,179.5a15.77,15.77,0,0,0,6.4,7.4,20.36,20.36,0,0,0,10.7,2.6,29,29,0,0,0,11-2,22.83,22.83,0,0,0,8.95-6.8l10.1,7.7a36.18,36.18,0,0,1-28.4,13.3,41.27,41.27,0,0,1-13.8-2.25,33.61,33.61,0,0,1-11.15-6.4,29.78,29.78,0,0,1-7.5-10.1,31.37,31.37,0,0,1-2.75-13.35,32.39,32.39,0,0,1,2.6-13.15,30.71,30.71,0,0,1,7.1-10.2,32,32,0,0,1,10.65-6.6,37,37,0,0,1,13.35-2.35,34.92,34.92,0,0,1,12.85,2.3A31.34,31.34,0,0,1,273.2,146a30.33,30.33,0,0,1,6.85,9.7A33.37,33.37,0,0,1,282.9,168Zm17.9-30q-8.91,0-14.05,4.95T231.2,167.9l36-8.6a16.71,16.71,0,0,0-6.8-7.5A19.5,19.5,0,0,0,250.9,149.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M308.8,120v78.7H293V120Z"
})));

function SvgLogo4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 308.8 201.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo4);
export default __webpack_public_path__ + "static/media/logo4.b273d3c0.svg";
export { ForwardRef as ReactComponent };